import React from 'react';

const About = () => {
    return (
        <div>
            <h2>Its a About Page</h2>
        </div>
    );
};

export default About;